import React, { Component } from 'react';
import EphielNavBar from "./components/EphielNavBar";
import RequestsJumbotron from "./components/RequestsJumbotron";
import { Container, Row, Col } from "reactstrap";
import AlertResultsPage from "./components/AlertResultsPage"
import { Provider } from "react-redux";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';

class Requests extends Component {
  componentDidMount() {
  }
  render() {
    return (

      <Provider store={store}>
        <EphielNavBar />
        <AlertResultsPage />
        <Container>
          <Row>
            <Col >
              <RequestsJumbotron />
            </Col>
          </Row>
        </Container>
      </Provider>
    );
  }
}


export default Requests;
